module.exports = __webpack_public_path__ + "20102dc2bbeda9999688620d732ee0e2.png";